import React from "react";
import { useDispatch, useSelector } from "react-redux";
import InputColor from "../../../../components/input/inputColor";
import { updateBuilder } from "../../../../redux/slices/linksBuilder";

export default function LinkListColorPicker({ title, numberColor }) {
  const { color, linksBuilderData } = useSelector((state) => ({
    color: state.linksBuilder.data.colors[numberColor],
    linksBuilderData: state.linksBuilder.data,
  }));
  const dispatch = useDispatch();

  const handleColor = (color) => {
    const colorSet = [...linksBuilderData.colors];
    colorSet[numberColor] = color;
    dispatch(updateBuilder({ ...linksBuilderData, colors: colorSet }));
  };

  return (
    <InputColor
      value={color}
      onChange={(color) => handleColor(color)}
      label={title}
      className="mb-0"
    />
  );
}
